import { IDetectableEnvironment } from './../../../environment/detectors/IDetectableEnvironment';
/**
 * Author: Artyom Goncharov
 *   Team: Client-Core
 *   User: agoncharov
 *   Date: 12.09.2014
 *   Time: 18:38
 */

import { ConcreteEnvironmentData } from "../data/ConcreteEnvironmentData";
import { ConcreteEnvironmentPatterns } from "../patterns/ConcreteEnvironmentPatterns";
import { IEnvironment } from "./IEnvironment";

export abstract class ConcreteEnvironment extends ConcreteEnvironmentPatterns implements IEnvironment, IDetectableEnvironment {
    protected _id: string;
    protected _data: ConcreteEnvironmentData = new ConcreteEnvironmentData();

    constructor(id: string) {
        super();
        this._id = id;
    }

    public abstract initPatterns(): void;

    public get id(): string {
        return this._id;
    }

    public get patterns(): ConcreteEnvironmentPatterns {
        return this;
    }

    public get data(): ConcreteEnvironmentData {
        return this._data;
    }

    public get detection(): IDetectableEnvironment {
        return this;
    }

    public isSupported(): boolean {
        return false;
    }
}
